import React from "react";

import { useSelector } from "react-redux";

import { FaInfoCircle } from "react-icons/fa";
import InfoPopupHover from "../components/InfoPopupHover";

export default function OfferFilter(props) {
  const { changeFilterAndSearch, changeClientFilter } = props;
  const loading = useSelector((state) => state.system.loading);

  const freecancellation = useSelector(
    (state) => state.search.freecancellation
  );

  const addablecancellation = useSelector(
    (state) => state.search.addablecancellation
  );

  const reservationoperatorsonly = useSelector(
    (state) => state.search.reservationoperatorsonly
  );

  const freerebook = useSelector((state) => state.search.freerebook);

  const infos = useSelector((state) => state.properties.infos);

 // console.log(infos);

  return (
    <div className="offerfilter">
      <div className="offerfilter1 filterheader">Stornierungsoptionen</div>
      <div className="filterrow">
        <div className="filter1">
          <input
            className="offerfilter3"
            disabled={loading > 0}
            type="checkbox"
            checked={freecancellation}
            onChange={() =>
              changeFilterAndSearch("freecancellation", !freecancellation)
            }
          />
        </div>
        <div className="filter2">
        <div className="filtertext"                   dangerouslySetInnerHTML={{
                    __html: "Kostenlos oder günstig stornierbar",
                  }}>
                </div>
          <InfoPopupHover
            trigger={<span ><FaInfoCircle className="filterinfo" /></span>}
            content={infos.kostenlos_oder_günstig_stornierbar}
            position={"right center"}
          ></InfoPopupHover>
        </div>
      </div>
      <div className="filterrow">
        <div className="filter1">
          <input
            disabled={loading > 0}
            type="checkbox"
            checked={freerebook}
            onChange={() => changeFilterAndSearch("freerebook", !freerebook)}
          />
        </div>
        <div className="filter2">
        <div className="filtertext"                   dangerouslySetInnerHTML={{
                    __html: "Kostenlose Umbuchung",
                  }}>
                </div>
          <InfoPopupHover
            trigger={<span ><FaInfoCircle className="filterinfo" /></span>}
            content={infos.kostenlose_umbuchung}
            position={"right center"}
          ></InfoPopupHover>
        </div>
      </div>
      <div className="filterrow">
        <div className="filter1">
          <input
            disabled={loading > 0}
            type="checkbox"
            checked={addablecancellation}
            onChange={() =>
              changeFilterAndSearch("addablecancellation", !addablecancellation)
            }
          />
        </div>
        <div className="filter2">
        <div className="filtertext"                   dangerouslySetInnerHTML={{
                    __html: "FLEX-Tarif zubuchbar",
                  }}>
                </div>
          <InfoPopupHover
            trigger={<span ><FaInfoCircle className="filterinfo" /></span>}
            content={infos.flex_option_zubuchbar}
            position={"right center"}
          ></InfoPopupHover>
        </div>
      </div>
      <div className="filterrow">
        <div className="filter1">
          <input
            disabled={loading > 0}
            type="checkbox"
            checked={reservationoperatorsonly}
            onChange={() =>
              changeClientFilter(
                "reservationoperatorsonly",
                !reservationoperatorsonly
              )
            }
          />
        </div>
        <div className="filter2">
        <div className="filtertext"                   dangerouslySetInnerHTML={{
                    __html: "3 Tage unverbindlich reservieren",
                  }}>
                </div>
          <InfoPopupHover
            trigger={<span ><FaInfoCircle className="filterinfo" /></span>}
            content={infos.einige_tage_ohne_anzahlung_reservieren}
            position={"right center"}
          ></InfoPopupHover>
        </div>
      </div>
    </div>
  );
}
